export const firebaseConfig = {
  apiKey: "AIzaSyBrIueLrp0_zwsuA498J-2IN3nait-9TVo",
  authDomain: "ecom-solo.firebaseapp.com",
  projectId: "ecom-solo",
  storageBucket: "ecom-solo.appspot.com",
  messagingSenderId: "566504264771",
  appId: "1:566504264771:web:9b513cee7b5046a3a430f6",
};
